module.exports = __webpack_public_path__ + "r-v3/img/ml_21_00.201f03f7.jpg";